import { render, staticRenderFns } from "./plantDetail.vue?vue&type=template&id=4f2ad57f&scoped=true"
import script from "./plantDetail.vue?vue&type=script&lang=js"
export * from "./plantDetail.vue?vue&type=script&lang=js"
import style0 from "./plantDetail.vue?vue&type=style&index=0&id=4f2ad57f&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f2ad57f",
  null
  
)

export default component.exports